import React, { useState, useEffect, useCallback } from "react";
import { useFormCtx } from "../FormContext";
import useScreenType from "./../hooks/useScreenType";
import * as Const from "./../_Const";

const ScreenSaver = ({ onActive, text = "Šetřič obrazovky - stiskněte obrazovku..." }) => {
  const [isActive, setActive] = useState(false);
  const { canShowScreenSaver, terminalSettingsState } = useFormCtx();
  const screenType = useScreenType();
  const [position, setPosition] = useState({ x: 0, y: 0 }); // Stav pro pozici textu

  // Funkce pro generování náhodné pozice
  const updateRandomPosition = useCallback(() => {
    // Získáme šířku a výšku aktuálního viewportu
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    //v teto fazi nacteni neni jeste znam druh displej screenType vraci 0 proto pouziju natvrdo viewportWidth
    //v1
    let offset = 300;
    //v2 + wavesahre
    if (viewportWidth >= 1200) {
      offset = 430;
    }

    // Generujeme náhodné souřadnice, aby text nebyl moc u kraje
    // Odečteme pevnou hodnotu, aby se text nevešel celý a nebyl oříznut
    const newX = Math.floor(Math.random() * (viewportWidth - offset)); // -400px pro text
    const newY = Math.floor(Math.random() * (viewportHeight - 100)); // -100px pro text

    setPosition({ x: newX, y: newY });
    //console.log(`ScreenSaver: Nová pozice [${newX}, ${newY}]`);
  }, []); // [] zajistí, že se funkce vytvoří jen jednou

  //handlovani scrensaveru
  useEffect(() => {
    let timeoutId;

    const scheduleNextcheck = () => {
      const now = new Date();
      const shouldShow = canShowScreenSaver();
      updateRandomPosition();

      // React změní stav (a překreslí stránku) jen pokud se hodnota skutečně změnila
      setActive((prev) => {
        if (prev === shouldShow) return prev;
        return shouldShow;
      });

      //callback do paarent page
      if (onActive) {
        onActive((prev) => {
          if (prev === shouldShow) return prev;
          return shouldShow;
        });
      }

      //chcemli spousten jen v celou minutu abych nepresvihnul internval
      // napriklad start 6:00 a check se provede v 5:59:59 tak se obrazovka probudi az v skoro 6:01 coz muze byt matouci pro obsluhu
      // Vypočítáme milisekundy do začátku další minuty + malá rezerva 100ms
      // Interval na default 60 sekund ale odescte se pocet sec do dalsi minuty aby se provedl cehck v celou minutu
      const msUntilNextMinute = (Const.SCREEN_SAVER_CHECK_INTERVAL - now.getSeconds()) * 1000 - now.getMilliseconds() + 100;

      timeoutId = setTimeout(scheduleNextcheck, msUntilNextMinute);
    };

    // Spustíme hned při načtení
    scheduleNextcheck();

    return () => clearTimeout(timeoutId);
  }, [terminalSettingsState]); // Reaguje jen na změnu nastavení

  function handleClicked() {
    //    updateRandomPosition();
    setActive(false);

    //callback do paarent page
    if (onActive) {
      onActive(false);
    }
  }

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "title":
          css = "text-md";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "title":
          css = "text-2xl";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "title":
          css = "text-2xl";
          break;
      }
    }
    //console.log(what, screenType, css);

    return css;
  }

  if (screenType === Const.SCREEN_UNKNOWN) {
    return;
  }

  return (
    <>
      {isActive && (
        <div
          className="fixed inset-0 bg-black z-[100] flex items-center justify-center cursor-none" // z-[100] pro extra vysoký z-index
          onClick={handleClicked} // Vypne šetřič při kliknutí
          onContextMenu={(e) => e.preventDefault()} // Zakáže kontextové menu
          style={{ WebkitUserSelect: "none", WebkitTouchCallout: "none" }} // Zakáže výběr textu
        >
          <p
            className={`${getCssFor("title")} text-primary text-center transition-all duration-1000 ease-in-out`} // Plynulá animace pohybu
            style={{
              position: "absolute", // Absolutní pozice pro přesné umístění
              left: `${position.x}px`,
              top: `${position.y}px`,
              pointerEvents: "none", // Důležité: aby klik na text prošel na div
            }}
          >
            {text}
          </p>
        </div>
      )}
    </>
  );
};

export default ScreenSaver;
